var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { QueryRoute, updateSearch } from 'bernie-core';
import { formatDate } from 'bernie-l10n';
import { Layer } from 'bernie-view';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { UitkDatePicker } from 'uitk-react-date-picker';
import { UitkSheetTransition } from 'uitk-react-sheet';
import { useStores } from '../../utils/hooks';
export var DateField = function (_a) {
  var buttonText = _a.buttonText,
    dateFieldProps = _a.dateFieldProps,
    endDate = _a.endDate,
    rfrr = _a.rfrr,
    startDate = _a.startDate,
    onChange = _a.onChange,
    daysBookableInAdvance = _a.daysBookableInAdvance,
    midnightBookingOffset = _a.midnightBookingOffset;
  var analytics = useStores().analytics;
  var history = useHistory();
  var _b = __read(React.useState(false), 2),
    mountStatus = _b[0],
    setMountStatus = _b[1];
  var _c = __read(React.useState(false), 2),
    showDatePicker = _c[0],
    setShowDatePicker = _c[1];
  var focusButtonRef = React.createRef();
  var startDateString = startDate ? startDate : '';
  var endDateString = endDate ? endDate : '';
  React.useEffect(function () {
    setMountStatus(true);
  }, [mountStatus]);
  var onOpen = function (dateType) {
    updateSearch({
      history: history,
      location: history.location,
      newParams: {
        pwaDialog: "datepicker-".concat(dateType)
      }
    });
    setShowDatePicker(true);
    if (rfrr && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(rfrr[dateType], 'availability-date-focus', analytics.omnitureData);
    }
  };
  var onDismiss = function () {
    updateSearch({
      history: history,
      location: history.location,
      newParams: {
        pwaDialog: ''
      }
    });
    var focusButton = focusButtonRef && focusButtonRef.current;
    if (focusButton && typeof focusButton.focus === 'function') {
      focusButton.focus();
    }
    setShowDatePicker(false);
  };
  var onSubmit = function (start, end) {
    var formattedEnd = formatDate(end, {
      raw: 'yyyy-MM-dd'
    });
    var formattedStart = formatDate(start, {
      raw: 'yyyy-MM-dd'
    });
    if (endDate !== formattedEnd || startDate !== formattedStart) {
      onChange({
        target: [{
          name: 'startDate',
          value: formatDate(start, {
            raw: 'yyyy-MM-dd'
          })
        }, {
          name: 'endDate',
          value: formatDate(end, {
            raw: 'yyyy-MM-dd'
          })
        }]
      });
    }
    onDismiss();
  };
  dateFieldProps.showDatePicker = showDatePicker;
  var dialogWrapper = function (children, dateType) {
    return React.createElement(QueryRoute, {
      query: {
        pwaDialog: "datepicker-".concat(dateType)
      }
    }, React.createElement(UitkSheetTransition, {
      isVisible: true
    }, React.createElement(Layer, {
      id: "home-datepicker-".concat(dateType),
      onDismiss: onDismiss
    }, children)));
  };
  var datePickerProps = {
    buttonText: buttonText,
    dateFieldProps: dateFieldProps,
    daysBookableInAdvance: daysBookableInAdvance,
    dialogWrapper: dialogWrapper,
    doubleMonths: true,
    endDate: endDateString,
    midnightBookingOffset: midnightBookingOffset,
    onDismissCB: onDismiss,
    onOpenCB: onOpen,
    onSubmitCB: onSubmit,
    startDate: startDateString,
    singleDateSelect: true
  };
  return React.createElement("div", {
    "data-testid": "search-date-picker"
  }, React.createElement(UitkDatePicker, __assign({}, datePickerProps)));
};